import React from 'react';
import { observer } from 'mobx-react';
import { Box, Button, Checkbox, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import { VariationScore } from 'components/VariationScore';
import { TextAsset } from '../../../../../../../types';
import useStyles from '../TextAssetItem.styles';
import { CreativeTemplatesEntities } from '../../../../../../../constants';
import { useHighlightTextAsset } from '../hooks/useHighlightTextAsset';

interface Props {
  textAsset: TextAsset;
  activeTabKey: CreativeTemplatesEntities;
  isSelected: boolean;
  isRemoving: boolean;
  isSuggestion: boolean;
  handleOpenEditMode: () => void;
  handleCopyToClipboard: () => void;
  handleRemove: () => void;
  handleSelect: () => void;
}

export const TextAssetViewMode: React.FC<Props> = observer(
  ({
    textAsset,
    activeTabKey,
    isSelected,
    isRemoving,
    isSuggestion,
    handleOpenEditMode,
    handleCopyToClipboard,
    handleRemove,
    handleSelect
  }: Props) => {
    const classes = useStyles(activeTabKey)();
    const { activeTextAsset } = useHighlightTextAsset(textAsset);

    return (
      <div className={classes.Container}>
        <div className={classes.ListItemContainer} onClick={handleSelect}>
          <ListItemIcon>
            <Checkbox
              edge="start"
              tabIndex={-1}
              disableRipple
              checked={isSelected}
              inputProps={{ 'aria-labelledby': `checkbox-list-label-${textAsset.id}` }}
            />
          </ListItemIcon>

          {textAsset.language && (
            <Typography variant="caption" className={classes.LanguageIndicator}>
              {textAsset.language.toUpperCase()}
            </Typography>
          )}

          <ListItemText
            id={`checkbox-list-label-${textAsset.id}`}
            primary={textAsset.isBlank ? 'BLANK' : textAsset.text}
            className={activeTextAsset ? classes.HighlightedListItemText : classes.ListItemText}
          />

          <Box className={classes.Score}>
            {textAsset.postMaloneScore && <VariationScore score={textAsset.postMaloneScore.engagementScore} />}
            {textAsset.isAutofilled && <Typography variant="caption">Autofill</Typography>}
            {isSuggestion && <Typography variant="caption">Suggestion</Typography>}
          </Box>
        </div>
        {activeTabKey !== CreativeTemplatesEntities.CTAs && (
          <div className="ButtonGroup">
            <Button
              color="primary"
              size="small"
              className={classes.Button}
              disabled={isRemoving || textAsset.isBlank || textAsset.isAutofilled || isSuggestion}
              onClick={handleOpenEditMode}
            >
              <span>edit</span>
            </Button>

            <Button
              size="small"
              color="primary"
              className={classes.Button}
              onClick={handleCopyToClipboard}
              disabled={isRemoving}
            >
              copy
            </Button>
            <Button
              size="small"
              className={classes.DeleteButton}
              onClick={handleRemove}
              disabled={isRemoving || textAsset.isBlank || textAsset.isAutofilled || isSuggestion}
            >
              delete
            </Button>
          </div>
        )}
      </div>
    );
  }
);
